const baseURL = process.env.REACT_APP_BASE_URL;
const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

// mongodb id length
const mongoOdLen = 24;

// ProductForm states
const CREATE_PRODUCT = 'CREATE_PRODUCT';
const EDIT_PRODUCT = 'EDIT_PRODUCT';
const COPY_PRODUCT = 'COPY_PRODUCT';

// Blog services modes
const BLOG_SERVICE_MODE = {
  CREATE_SERVICE: 'CREATE_SERVICE',
  EDIT_SERVICE: 'EDIT_SERVICE',
};
// Blog authors modes
const BLOG_AUTHOR_MODE = {
  CREATE_AUTHOR: 'CREATE_AUTHOR',
  EDIT_AUTHOR: 'EDIT_SERVICE',
};

// blog post status
const blogStatus = {
  DRAFT: 0,
  PUBLISH: 1,
  HIDDEN: 2,
  DELETE: 3,
};

const blogStatusObj = {
  [blogStatus.DRAFT]: { name: 'پیش نویس', id: `${blogStatus.DRAFT}` },
  [blogStatus.PUBLISH]: { name: 'انتشار', id: `${blogStatus.PUBLISH}` },
  [blogStatus.HIDDEN]: { name: 'مخفی', id: `${blogStatus.HIDDEN}` },
  [blogStatus.DELETE]: { name: 'حذف', id: `${blogStatus.DELETE}` },
};

const TEMPLATE_1 = '5fd739bf4e1cc93357419479';
const TEMPLATE_2 = '60bf07eacbc8d61c48c31a78';
const TEMPLATE_3 = '60ebd170bb3bff103634b23e';
const TEMPLATE_4 = '613358590dd73816b99af454';

// MegaMenu modes
const EDIT_MENU = 'EDIT_MENU';
const CREATE_MENU = 'CREATE_MENU';

const RANGE_FILTER_MAX_VALUE = Math.pow(10, 19) - 1;

const docValidationStatuses = [
  { status: 0, text: 'در حال بررسی', bgColor: 'yellow', color: 'white' },
  { status: 1, text: 'تایید شده', bgColor: 'green', color: 'white' },
  { status: 2, text: 'رد شده', bgColor: 'red', color: 'white' },
];

const postChainRemoveModes = {
  1: { ep: '/removePost', psi: false },
  2: { ep: '/removeSitePost', psi: true },
  3: { ep: '/remove', psi: false },
};

const bannersPositionTypes = {
  2: { title: 'بنرهای ثابت بالا' },
  3: { title: 'بنرهای ثابت پایین' },
};

const sliderStatus = {
  0: 'غیرفعال',
  1: 'فعال',
};

const sliderType = {
  slider: 2,
  tile: 3,
  mobile: 4,
};

// درخواست درگاه پرداخت
const ipgSt = {
  0: { title: 'پیش نویس', color: 'blue' },
  1: { title: 'در خواست شده', color: 'yellow' },
  2: { title: 'فعال', color: 'green' },
  3: { title: 'رد شده', color: 'red' },
};

// نام فیلد های لوگوی تنظیمات پرسونال سایت توی بک اند با فرانت فرق میکنه و اینو ساختیم ک تشخیص بدیم کدوم به کدومه.
const personalSiteLogoTagNames = {
  headerLogo: 'logo',
  footerLogo: 'logoFooter',
  favIcon: 'favIcon',
  loginBanner: 'loginMedia',
};

const BUSINESS_AVATAR = 'BUSINESS_AVATAR';
const BUSINESS_LOGO = 'BUSINESS_LOGO';
const SLIDER = 'SLIDER';
const BUSINESS_VALIDATION = 'BUSINESS_VALIDATION';
const POST_CHAIN = 'POST_CHAIN';
const UPLOAD_MEDIA_FOREIGN_TYPES = {
  [BUSINESS_AVATAR]: 1,
  [BUSINESS_LOGO]: 2,
  [SLIDER]: 9,
  [BUSINESS_VALIDATION]: 15,
  [POST_CHAIN]: 19,
};

const userRoles = {
  NORMAL_USER: 1,
  SITE_OWNER: 2,
};

const productTypes = {
  NORMAL_POST: 'NORMAL_POST',
  RESTAURANT_POST: 'RESTAURANT_POST',
};

// post create subscriber events
const POST_CHAIN_CREATED_SUCCESSFULLY = 'POST_CHAIN_CREATED_SUCCESSFULLY';
const POST_CHAIN_MEDIAS_UPLOADED_SUCCESSFULLY =
  'POST_CHAIN_MEDIAS_UPLOADED_SUCCESSFULLY';
const POST_CREATED_SUCCESSFULLY = 'POST_CREATED_SUCCESSFULLY';
const POST_CHAIN_NEW_MEDIAS_UPLOADED_SUCCESSFULLY =
  'POST_CHAIN_NEW_MEDIAS_UPLOADED_SUCCESSFULLY';
const POST_EDITED_SUCCESSFULLY = 'POST_EDITED_SUCCESSFULLY';

const SITE_MEDIA_UPLOAD_TYPE = 'siteInfo';

export {
  baseURL,
  bannersPositionTypes,
  imageBaseUrl,
  mongoOdLen,
  postChainRemoveModes,
  RANGE_FILTER_MAX_VALUE,
  docValidationStatuses,
  // product form modes:
  CREATE_PRODUCT,
  EDIT_PRODUCT,
  COPY_PRODUCT,
  // media foreign types:
  UPLOAD_MEDIA_FOREIGN_TYPES,
  sliderStatus,
  sliderType,
  ipgSt,
  personalSiteLogoTagNames,
  userRoles,
  POST_CHAIN_CREATED_SUCCESSFULLY,
  POST_CHAIN_MEDIAS_UPLOADED_SUCCESSFULLY,
  POST_CREATED_SUCCESSFULLY,
  POST_CHAIN_NEW_MEDIAS_UPLOADED_SUCCESSFULLY,
  POST_EDITED_SUCCESSFULLY,
  EDIT_MENU,
  CREATE_MENU,
  productTypes,
  TEMPLATE_1,
  TEMPLATE_2,
  TEMPLATE_3,
  TEMPLATE_4,
  BLOG_SERVICE_MODE,
  BLOG_AUTHOR_MODE,
  blogStatus,
  blogStatusObj,
  SITE_MEDIA_UPLOAD_TYPE,
};
